const _ = require('lodash');
const cachedTokens = {};

function SecureApiCall(ProxyService, CurrentUserService, SecureApiRoutes, UrlService) {
    this.proxyService = ProxyService;
	this.currentUserService = CurrentUserService;
	this.routes = SecureApiRoutes;
	this.urlService = UrlService;
}

SecureApiCall.prototype.call = function (cb) {
	const user = this.currentUserService.get();
	const config = { headers: { Authorization: '' } };
	const token = cachedTokens[user.id];

	if (token && !token.hasExpired()) {
		config.headers.Authorization = `Bearer ${token.accessToken}`;
		return cb(token, config);
	}

	return this.getToken(user).then((freshToken) => {
		config.headers.Authorization = `Bearer ${freshToken.accessToken}`;
		return cb(freshToken, config);
	});
};

SecureApiCall.prototype.getToken = function (user) {

	if (_.isUndefined(user) || _.isUndefined(user.id) || _.isUndefined(user.email)) {
		throw new Error('Unable to generate token');
	}

    const url = this.routes.token;
	const request = {
		shopperId: '' + user.id,
		userEmail: user.email
	};

    return this.proxyService.post(url, 'bazaar', JSON.stringify(request)).then((response) => {

		const tokenResponse = {
            accessToken: response.access_token,
            expiresIn: response.expires_in,
			retrievedOn: new Date(),
			hasExpired: () => {
				const expiryDate = new Date(tokenResponse.retrievedOn);
				expiryDate.setMinutes(tokenResponse.retrievedOn.getMinutes() + tokenResponse.expiresIn);
				return (new Date() > expiryDate);
			}
		};

		cachedTokens[user.id] = tokenResponse;
		return tokenResponse;
	});
};

module.exports = SecureApiCall;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/secure-api-call.js
 **/